var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"title":"Cottonseed Bids"}},[_c('settings-layout',[_c('cottonseed-bids-accepted-list',{attrs:{"items":_vm.items}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }